import { useTranslation } from 'react-i18next';

import { Div } from "ui"

import OverlaySVG from './OverlaySVG'
import baseIMG from 'assets/images/flixx/textCard1_base.png'
import { Flixx, Text } from 'ui/index';


const TextCard1 = (props) => {

  const { t } = useTranslation()

  return (
    <Div
      position='relative'
      width='100%'
      height='100%'
    >
      <Div
        position='absolute'
        top='15.2%'
        left='5.4%'
        height='77%'
        width='89%'
      >
        <OverlaySVG height='100%' width='100%' />
      </Div>

      <Div
        position='absolute'
        top='19%'
        left='50%'
        transform='translateX(-50%)'
        width='85%'
      >
        <Div width='95%' margin='0 auto' textAlign='center'>
          <Text as='span' color='headline' size='sm' weight='semibold'>
            {t('flixx_watchAd_exampleTitle')}
          </Text>
          {' '}
          <Flixx size='sm' price='1.02' />
        </Div>

        <Div margin='10px auto 0' width='80%'>
          <Text align='center' color='headline' size='xs'>
            {t('flixx_watchAd_exampleDescription')}
          </Text>
        </Div>
      </Div>

      <img 
        height='100%'
        width='100%'
        src={`${baseIMG}`}
        alt=''
      />
    </Div>
  )
}

export default TextCard1
